module.exports = __webpack_public_path__ + "img/artist_header_en_mobile.adf0c2f.webp";